import React from 'react';
import { ProjectLogsSummary } from './ProjectLogsSummary';
import { ProjectLogsStats } from './ProjectLogsStats';
import { ProjectLogsRecent } from './ProjectLogsRecent';

export function ProjectLogsSidebar({ data }: { data: any }) {
  return (
    <div className="space-y-6">
      {/* Tóm tắt hoạt động */}
      <ProjectLogsSummary summary={data.summary} />

      {/* Hoạt động theo loại */}
      <ProjectLogsStats />

      {/* Hoạt động gần đây */}
      <ProjectLogsRecent />
    </div>
  );
}
